export default __webpack_public_path__ + "pgnv-assets/d45e8c4380c29962e4da2c094c02e027.svg";